import { createContext, useContext } from 'react';

const FormReadOnlyContext = createContext(false);
export const FormReadOnlyProvider = FormReadOnlyContext.Provider;
export const useFormReadOnly = () => useContext(FormReadOnlyContext);
